import initializeParameters from 'application/initializeParameters'
import { ApplicationState } from 'application/redux'
import { resetPageNumber } from 'core/pagination-optimized/redux/actions'
import { clearAllFilters } from 'core/search/redux/action'
import { sideMenuClearCache } from 'core/side-menu/redux/action'
import { clearAccordionCache } from 'core/table-accordion/redux/actions'
import { clearTableCache } from 'core/table/redux/actions'
import { connect } from 'react-redux'
import { clearSettingsCache } from '../detail/_settings/redux/actions'
import { cleanChannelsResult, stopChannelScan } from '../detail/channels/redux/actions'
import { cleanScanResult } from '../detail/channels/scan/redux/actions'
import { clearCacheDvr } from '../detail/dvr/redux/actions'
import { clearCacheGeneralDeviceInfo } from '../detail/general/redux/actions'
import { clearThreshold } from '../detail/hard-disk/redux/actions'
import { clearCacheOverview } from '../detail/overview/redux/actions'
import { clearCacheProvDevices } from '../detail/provisioned-devices/redux/actions'
import { clearCacheTabRFtuning } from '../detail/rf-tuning/redux/actions'
import { clearScanCache, stopSingleRftuning } from '../detail/rf-tuning/scan/redux/actions'
import { clearCacheRFTuning, stopChannelStats } from '../detail/rf-tuning/status/redux/actions'
import { clearCacheSpeedTest, stopSpeedTest } from '../detail/speed-test/redux/actions'
import { clearCacheSubscriptions } from '../detail/subscriptions/redux/actions'
import { clearCacheVod } from '../detail/vod/redux/actions'
import AdvancedSearchComponent from './advanced-search-component'
import {
  fetchAdvancedSearch,
  loadDeviceCustomFields,
  onChangeAdvancedSearchPage
} from './redux/action'

const mapStateToProps = (state: ApplicationState) => ({
  application: state.application,
  results: state.devices.advancedSearch.execution.results,
  resultsToShow: state.devices.advancedSearch.execution.resultsToShow,
  totalElements: state.devices.advancedSearch.execution.totalElements,
  lastEvaluatedData: state.devices.advancedSearch.execution.lastEvaluatedData,
  currentHistory: state.devices.advancedSearch.history.current,
  applicationParameters: state.application.parameters.map,
  pagination: state.pagination,
  multipleSearch: state.multipleSearch,
  t: state.i18n.t,
})

export default connect(mapStateToProps, {
  fetchAdvancedSearch,
  initializeParameters,
  loadDeviceCustomFields,
  clearCacheVod,
  clearCacheDvr,
  clearCacheSpeedTest,
  clearCacheSubscriptions,
  clearCacheProvDevices,
  clearCacheRFTuning,
  clearAllFilters,
  resetPageNumber,
  clearTableCache,
  onChangeAdvancedSearchPage,
  clearCacheGeneralDeviceInfo,
  clearCacheOverview,
  stopSpeedTest,
  stopChannelScan,
  stopChannelStats,
  cleanChannelsResult,
  cleanScanResult,
  clearAccordionCache,
  clearSettingsCache,
  sideMenuClearCache,
  clearCacheTabRFtuning,
  clearScanCache,
  stopSingleRftuning,
  clearThreshold,
})(AdvancedSearchComponent)
